import React from 'react';
import { Home, AlertCircle, Package, Settings, X, Building2, ClipboardList } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { PropertySelector } from './PropertySelector';
interface SidebarProps {
  isOpen?: boolean;
  onClose?: () => void;
}
export function Sidebar({
  isOpen = true,
  onClose
}: SidebarProps) {
  const location = useLocation();
  const navItems = [{
    icon: Home,
    label: 'Home',
    path: '/'
  }, {
    icon: ClipboardList,
    label: 'Pulizie',
    path: '/pulizie'
  }, {
    icon: AlertCircle,
    label: 'Segnalazioni',
    path: '/messaggi'
  }];
  const secondaryItems = [{
    icon: Building2,
    label: 'Proprietà',
    path: '/scheda-proprieta'
  }, {
    icon: Package,
    label: 'Acquista pacchetti',
    path: '/abbonamenti'
  }, {
    icon: Settings,
    label: 'Impostazioni',
    path: '/impostazioni'
  }];
  const handleLinkClick = () => {
    if (onClose) {
      onClose();
    }
  };
  return <>
      {/* Mobile Overlay */}
      {isOpen && onClose && <div className="fixed inset-0 bg-black/50 z-40 lg:hidden" onClick={onClose} data-id="element-727" />}

      {/* Sidebar — always expanded on desktop, slide-in on mobile */}
      <aside className={`
          bg-[#0D1B6F] h-screen fixed left-0 top-0 flex flex-col z-50
          w-64 lg:translate-x-0
          transition-transform duration-300 ease-in-out
          ${isOpen ? 'translate-x-0' : '-translate-x-full'}
        `} data-id="element-728">
        {/* Logo Header */}
        <div className="h-16 px-4 border-b border-white/10 flex items-center justify-between flex-shrink-0" data-id="element-729">
          <span className="text-2xl font-bold tracking-tight select-none" data-id="element-730">
            <span className="text-white" data-id="element-731">Clean</span>
            <span className="text-teal-deep" data-id="element-732">AI</span>
          </span>

          {/* Close button — mobile only */}
          {onClose && <button onClick={onClose} className="lg:hidden p-2 hover:bg-white/10 rounded-full transition-colors" data-id="element-733">
              <X size={20} className="text-white" data-id="element-734" />
            </button>}
        </div>

        {/* Property Selector */}
        <PropertySelector isCollapsed={false} data-id="element-735" />

        {/* Navigation */}
        <nav className="flex-1 px-3 py-2 overflow-y-auto" data-id="element-736">
          {/* Primary section */}
          <div className="mb-1" data-id="element-737">
            <p className="px-3 pt-3 pb-2 text-[11px] font-semibold text-white/40 uppercase tracking-widest" data-id="element-738">
              Menu
            </p>
            <ul className="space-y-0.5" data-id="element-739">
              {navItems.map(item => {
              const Icon = item.icon;
              const isActive = item.path === '/' ? location.pathname === '/' || location.pathname === '/dashboard' : location.pathname === item.path;
              return <li key={item.label} data-id="element-740">
                    <Link to={item.path} onClick={handleLinkClick} className={`
                        w-full flex items-center gap-3 rounded-xl px-3 py-2.5
                        transition-all duration-150 min-h-[42px]
                        ${isActive ? 'bg-coral text-white font-medium' : 'text-white/60 hover:bg-white/8 hover:text-white/90'}
                      `} data-id="element-741">
                      <Icon className={`w-[18px] h-[18px] flex-shrink-0 ${isActive ? 'text-white' : ''}`} data-id="element-742" />
                      <span className="text-[14px]" data-id="element-743">{item.label}</span>
                    </Link>
                  </li>;
            })}
            </ul>
          </div>

          {/* Secondary section */}
          <div className="mt-4" data-id="element-744">
            <p className="px-3 pt-3 pb-2 text-[11px] font-semibold text-white/40 uppercase tracking-widest" data-id="element-745">
              Gestione
            </p>
            <ul className="space-y-0.5" data-id="element-746">
              {secondaryItems.map(item => {
              const Icon = item.icon;
              const isActive = location.pathname === item.path;
              return <li key={item.label} data-id="element-747">
                    <Link to={item.path} onClick={handleLinkClick} className={`
                        w-full flex items-center gap-3 rounded-xl px-3 py-2.5
                        transition-all duration-150 min-h-[42px]
                        ${isActive ? 'bg-coral text-white font-medium' : 'text-white/60 hover:bg-white/8 hover:text-white/90'}
                      `} data-id="element-748">
                      <Icon className={`w-[18px] h-[18px] flex-shrink-0 ${isActive ? 'text-white' : ''}`} data-id="element-749" />
                      <span className="text-[14px]" data-id="element-750">{item.label}</span>
                    </Link>
                  </li>;
            })}
            </ul>
          </div>
        </nav>
      </aside>
    </>;
}